import { PhotoModel } from "@/models/photo.model.ts";
import pixelArt from "@/assets/styles/pixel-art.webp";
import oilPainting from "@/assets/styles/oil-painting.webp";
import pencilSketch from "@/assets/styles/pencil-sketch.webp";
import watercolor from "@/assets/styles/watercolor.webp";
import render from "@/assets/styles/render.webp";
import fantasy from "@/assets/styles/fantasy.webp";
import cyberpunk from "@/assets/styles/cyberpunk.webp";
import sticker from "@/assets/styles/sticker.webp";
import realistic from "@/assets/styles/realistic.webp";
import shallowDepthOfField from "@/assets/focus/shallow-depth-of-field.webp";
import deepFocus from "@/assets/focus/deep-focus.webp";
import tiltShift from "@/assets/focus/tilt-shift.webp";
import bokeh from "@/assets/focus/bokeh.webp";
import natural from "@/assets/lighting/natural.webp";
import daylight from "@/assets/lighting/daylight.webp";
import soft from "@/assets/lighting/soft.webp";
import studio from "@/assets/lighting/studio.webp";
import hard from "@/assets/lighting/hard.webp";
import rim from "@/assets/lighting/rim.webp";
import broad from "@/assets/lighting/broad.webp";
import rembrandt from "@/assets/lighting/rembrandt.webp";
import hair from "@/assets/lighting/hair.webp";
import spotlight from "@/assets/lighting/spotlight.webp";
import neon from "@/assets/lighting/neon.webp";
import goldenHour from "@/assets/lighting/golden-hour.webp";
import angry from "@/assets/expressions/angry.webp";
import confident from "@/assets/expressions/confident.webp";
import confused from "@/assets/expressions/confused.webp";
import excited from "@/assets/expressions/excited.webp";
import happy from "@/assets/expressions/happy.webp";
import laughing from "@/assets/expressions/laughing.webp";
import sad from "@/assets/expressions/sad.webp";
import scared from "@/assets/expressions/scared.webp";
import serious from "@/assets/expressions/serious.webp";
import smiling from "@/assets/expressions/smiling.webp";
import black from "@/assets/backgrounds/black.webp";
import blue from "@/assets/backgrounds/blue.webp";
import brown from "@/assets/backgrounds/brown.webp";
import city from "@/assets/backgrounds/city.webp";
import colorful from "@/assets/backgrounds/colorful.webp";
import darkGray from "@/assets/backgrounds/dark-gray.webp";
import forest from "@/assets/backgrounds/forest.webp";
import gray from "@/assets/backgrounds/gray.webp";
import green from "@/assets/backgrounds/green.webp";
import lake from "@/assets/backgrounds/lake.webp";
import library from "@/assets/backgrounds/library.webp";
import lightGray from "@/assets/backgrounds/light-gray.webp";
import livingRoom from "@/assets/backgrounds/living-room.webp";
import naturalBg from "@/assets/backgrounds/natural.webp";
import office from "@/assets/backgrounds/office.webp";
import pink from "@/assets/backgrounds/pink.webp";
import purple from "@/assets/backgrounds/purple.webp";
import red from "@/assets/backgrounds/red.webp";
import river from "@/assets/backgrounds/river.webp";
import sea from "@/assets/backgrounds/sea.webp";
import white from "@/assets/backgrounds/white.webp";
import front from "@/assets/angles/front.webp";
import side from "@/assets/angles/side.webp";
import angle from "@/assets/angles/angle.webp";
import headshot from "@/assets/angles/headshot.webp";
import { cva } from "class-variance-authority";
// hairstyles - men
import buzzCut from "@/assets/hairstyles/men/buzz-cut.webp";
import crewCut from "@/assets/hairstyles/men/crew-cut.webp";
import curlyCutWithLayers from "@/assets/hairstyles/men/curly-cut-with-layers.webp";
import longCurlyHairWithSidePart from "@/assets/hairstyles/men/long-curly-hair-with-side-part.webp";
import longHair from "@/assets/hairstyles/men/long-hair.webp";
import mediumSpikedFadeOnFauxHawk from "@/assets/hairstyles/men/medium-spiked-fade-on-faux-hawk-haircut.webp";
import ponytail from "@/assets/hairstyles/men/ponytail.webp";
import quiff from "@/assets/hairstyles/men/quiff.webp";
import shortFloppyWithBangs from "@/assets/hairstyles/men/short-floppy-with-bangs.webp";
import sidePart from "@/assets/hairstyles/men/side-part.webp";
import texturedFloppyCut from "@/assets/hairstyles/men/textured-floppy-cut.webp";
import afro from "@/assets/hairstyles/men/afro.webp";
// hairstyles - women
import afroW from "@/assets/hairstyles/women/afro.webp";
import bangs from "@/assets/hairstyles/women/bangs.webp";
import bun from "@/assets/hairstyles/women/bun.webp";
import buzzCutW from "@/assets/hairstyles/women/buzz-cut.webp";
import chignon from "@/assets/hairstyles/women/chignon.webp";
import doubleBun from "@/assets/hairstyles/women/double-bun.webp";
import feathered from "@/assets/hairstyles/women/feathered.webp";
import fishtailBraid from "@/assets/hairstyles/women/fishtail-braid.webp";
import highPonytail from "@/assets/hairstyles/women/high-ponytail.webp";
import longBohemianBraids from "@/assets/hairstyles/women/long-bohemian-braids.webp";
import longCurly from "@/assets/hairstyles/women/long-curly.webp";
import longGatsbyWaves from "@/assets/hairstyles/women/long-gatsby-waves.webp";
import longSleekPonytail from "@/assets/hairstyles/women/long-sleek-ponytail.webp";
import longStraight from "@/assets/hairstyles/women/long-straight.webp";
import mediumSenegaleseTwist from "@/assets/hairstyles/women/medium-senegalese-twist.webp";
import mediumTwoStrandTwists from "@/assets/hairstyles/women/medium-two-strand-twists.webp";
import ombre from "@/assets/hairstyles/women/ombre.webp";
import short from "@/assets/hairstyles/women/short.webp";
import shortCurlyAfro from "@/assets/hairstyles/women/short-curly-afro.webp";
import shortTexturedQuiff from "@/assets/hairstyles/women/short-textured-quiff.webp";
import sleekBob from "@/assets/hairstyles/women/sleek-bob.webp";
import sleekStraight from "@/assets/hairstyles/women/sleek-straight.webp";
import topKnot from "@/assets/hairstyles/women/top-knot.webp";
import twinBraids from "@/assets/hairstyles/women/twin-braids.webp";
// body
import shirtUrl from "@/assets/accessories/men/body/shirt.webp";
import tshirtUrl from "@/assets/accessories/men/body/tshirt.webp";
import hoodieUrl from "@/assets/accessories/men/body/hoodie.webp";
import tankTopUrl from "@/assets/accessories/men/body/tank-top.webp";
import poloShirtUrl from "@/assets/accessories/men/body/polo-shirt.webp";
import sweaterUrl from "@/assets/accessories/men/body/sweater.webp";
import turtleneckUrl from "@/assets/accessories/men/body/turtleneck.webp";
import bodysuitUrl from "@/assets/accessories/women/body/bodysuit.webp";
import cropTopUrl from "@/assets/accessories/women/body/crop-top.webp";
import halterTopUrl from "@/assets/accessories/women/body/halter-top.webp";
import tubeTopUrl from "@/assets/accessories/women/body/tube-top.webp";
import tunicsUrl from "@/assets/accessories/women/body/tunics.webp";
import dressUrl from "@/assets/accessories/women/body/dress.webp";
import bikiniSwimmingSuitUrl from "@/assets/accessories/women/body/bikini-swimming-suit.webp";
import fullBodySwimmingSuitUrl from "@/assets/accessories/women/body/full-body-swimming-suit.webp";
// outerwear
import suitJacketUrl from "@/assets/accessories/men/outerwear/suit-jacket.webp";
import denimJacketUrl from "@/assets/accessories/men/outerwear/denim-jacket.webp";
import leatherJacketUrl from "@/assets/accessories/men/outerwear/leather-jacket.webp";
import parkaUrl from "@/assets/accessories/men/outerwear/parka.webp";
import pufferJacketUrl from "@/assets/accessories/men/outerwear/puffer-jacket.webp";
import windbreakerUrl from "@/assets/accessories/men/outerwear/windbreaker.webp";
import peaCoatUrl from "@/assets/accessories/men/outerwear/pea-coat.webp";
import trenchCoatUrl from "@/assets/accessories/men/outerwear/trench-coat.webp";
import bomberJacketUrl from "@/assets/accessories/men/outerwear/bomber-jacket.webp";
import cardiganUrl from "@/assets/accessories/women/outerwear/cardigan.webp";
import coatUrl from "@/assets/accessories/women/outerwear/coat.webp";
import jacketUrl from "@/assets/accessories/women/outerwear/jacket.webp";
import ponchosUrl from "@/assets/accessories/women/outerwear/ponchos.webp";
import shrugsUrl from "@/assets/accessories/women/outerwear/shrugs.webp";
import vestUrl from "@/assets/accessories/women/outerwear/vest.webp";
// legs
import cargoPantsUrl from "@/assets/accessories/men/legs/cargo-pants.webp";
import chinnosUrl from "@/assets/accessories/men/legs/chinnos.webp";
import dressPantsUrl from "@/assets/accessories/men/legs/dress-pants.webp";
import jeansUrl from "@/assets/accessories/men/legs/jeans.webp";
import joggersUrl from "@/assets/accessories/men/legs/joggers.webp";
import overallsUrl from "@/assets/accessories/men/legs/overalls.webp";
import shortsUrl from "@/assets/accessories/men/legs/shorts.webp";
import sweatPantsUrl from "@/assets/accessories/men/legs/sweat-pants.webp";
import culottesUrl from "@/assets/accessories/women/legs/culottes.webp";
import formalShortsUrl from "@/assets/accessories/women/legs/formal-shorts.webp";
import haremPantsUrl from "@/assets/accessories/women/legs/harem-pants.webp";
import jeggingsUrl from "@/assets/accessories/women/legs/jeggings.webp";
import leggingsUrl from "@/assets/accessories/women/legs/leggings.webp";
import maxiSkirtUrl from "@/assets/accessories/women/legs/maxi-skirt.webp";
import miniSkirtUrl from "@/assets/accessories/women/legs/mini-skirt.webp";
import palazzoPantsUrl from "@/assets/accessories/women/legs/palazzo-pants.webp";
import pencilSkirtUrl from "@/assets/accessories/women/legs/pencil-skirt.webp";
import tailoredShortsUrl from "@/assets/accessories/women/legs/tailored-shorts.webp";
// shoes
import boatShoesUrl from "@/assets/accessories/men/footwear/boat-shoes.webp";
import bootsUrl from "@/assets/accessories/men/footwear/boots.webp";
import chelseaBootsUrl from "@/assets/accessories/men/footwear/chelsea-boots.webp";
import flipFlopsUrl from "@/assets/accessories/men/footwear/flip-flops.webp";
import loafersUrl from "@/assets/accessories/men/footwear/loafers.webp";
import moccasinsUrl from "@/assets/accessories/men/footwear/moccasins.webp";
import oxfordsUrl from "@/assets/accessories/men/footwear/oxfords.webp";
import sandalsUrl from "@/assets/accessories/men/footwear/sandals.webp";
import slippersUrl from "@/assets/accessories/men/footwear/slippers.webp";
import sneakersUrl from "@/assets/accessories/men/footwear/sneakers.webp";
import espadrillesUrl from "@/assets/accessories/men/footwear/espadrilles.webp";
import sportShoesUrl from "@/assets/accessories/men/footwear/sport-shoes.webp";
import heelsUrl from "@/assets/accessories/women/footwear/heels.webp";
// accessories
import sunglassesUrl from "@/assets/accessories/men/accessories/sunglasses.webp";
import glassesUrl from "@/assets/accessories/men/accessories/glasses.webp";
import beanieUrl from "@/assets/accessories/men/accessories/beanie.webp";
import scarfUrl from "@/assets/accessories/men/accessories/scarf.webp";
import tieUrl from "@/assets/accessories/men/accessories/tie.webp";
import bowTieUrl from "@/assets/accessories/men/accessories/bow-tie.webp";
import glovesUrl from "@/assets/accessories/men/accessories/gloves.webp";
import baseballCapUrl from "@/assets/accessories/men/accessories/baseball-cap.webp";
import earringsUrl from "@/assets/accessories/women/accessories/earrings.webp";
import handbagUrl from "@/assets/accessories/women/accessories/handbag.webp";
import necklaceUrl from "@/assets/accessories/women/accessories/necklace.webp";

export type AccessoryState = {
  [key: string]: string | null;
};

export type AccessoryAction = {
  type: "SET_ACCESSORY" | "RESET_ALL";
  payload?: {
    name: string;
    value: string | null;
  };
};

interface AccessoryGroup {
  image: string;
  title: string;
  handle: string;
  description: string;
  panels: Panel[];
}

interface Panel {
  group: string;
  image: string;
  label: string;
}

export const initialAccessoriesState: AccessoryState = {
  // body
  "t-shirt": null,
  shirt: null,
  "polo-shirt": null,
  hoodie: null,
  sweater: null,
  turtleneck: null,
  dress: null,
  bodysuit: null,
  "crop-top": null,
  "halter-top": null,
  "tube-top": null,
  tunics: null,
  "bikini-swimming-suit": null,
  "full-body-swimming-suit": null,
  "tank-top": null,
  // outerwear
  "suit-jacket": null,
  "denim-jacket": null,
  "leather-jacket": null,
  parka: null,
  "puffer-jacket": null,
  windbreaker: null,
  "pea-coat": null,
  "trench-coat": null,
  "bomber-jacket": null,
  cardigan: null,
  coat: null,
  jacket: null,
  ponchos: null,
  shrugs: null,
  vest: null,
  // legs
  "cargo-pants": null,
  chinnos: null,
  "dress-pants": null,
  jeans: null,
  joggers: null,
  overalls: null,
  shorts: null,
  "sweat-pants": null,
  culottes: null,
  "formal-shorts": null,
  "harem-pants": null,
  jeggings: null,
  leggings: null,
  "maxi-skirt": null,
  "mini-skirt": null,
  "palazzo-pants": null,
  "pencil-skirt": null,
  "tailored-shorts": null,
  // shoes
  "boat-shoes": null,
  boots: null,
  "chelsea-boots": null,
  "flip-flops": null,
  loafers: null,
  moccasins: null,
  oxfords: null,
  sandals: null,
  slippers: null,
  sneakers: null,
  espadrilles: null,
  "sport-shoes": null,
  heels: null,
  // accessories
  sunglasses: null,
  glasses: null,
  beanie: null,
  scarf: null,
  tie: null,
  "bow-tie": null,
  gloves: null,
  "baseball-cap": null,
  earrings: null,
  handbag: null,
  necklace: null,
};

export function accessoryReducer(
  state: AccessoryState,
  action: AccessoryAction,
): AccessoryState {
  switch (action.type) {
    case "SET_ACCESSORY":
      return action.payload
        ? { ...state, [action.payload.name]: action.payload.value }
        : state;
    case "RESET_ALL":
      return Object.keys(state).reduce(
        (acc, key) => ({ ...acc, [key]: null }),
        {},
      );
    default:
      return state;
  }
}

// Groups configuration - moved outside component
export const accessoryGroups: AccessoryGroup[] = [
  {
    image: tshirtUrl,
    title: "Body clothes",
    handle: "body-clothes",
    description: "Clothes worn on the upper body in many shapes and forms.",
    panels: [
      {
        group: "tank-top",
        image: tankTopUrl,
        label: "Tank top",
      },
      {
        group: "t-shirt",
        image: tshirtUrl,
        label: "T-shirt",
      },
      {
        group: "polo-shirt",
        image: poloShirtUrl,
        label: "Polo shirt",
      },
      {
        group: "shirt",
        image: shirtUrl,
        label: "Shirt",
      },
      {
        group: "hoodie",
        image: hoodieUrl,
        label: "Hoodie",
      },
      {
        group: "sweater",
        image: sweaterUrl,
        label: "Sweater",
      },
      {
        group: "turtleneck",
        image: turtleneckUrl,
        label: "Turtleneck",
      },
      {
        group: "dress",
        image: dressUrl,
        label: "Dress",
      },
      {
        group: "bodysuit",
        image: bodysuitUrl,
        label: "Bodysuit",
      },
      {
        group: "crop-top",
        image: cropTopUrl,
        label: "Crop top",
      },
      {
        group: "halter-top",
        image: halterTopUrl,
        label: "Halter top",
      },
      {
        group: "tube-top",
        image: tubeTopUrl,
        label: "Tube top",
      },
      {
        group: "tunics",
        image: tunicsUrl,
        label: "Tunics",
      },
      {
        group: "bikini-swimming-suit",
        image: bikiniSwimmingSuitUrl,
        label: "Bikini swimming suit",
      },
      {
        group: "full-body-swimming-suit",
        image: fullBodySwimmingSuitUrl,
        label: "Full body swimming suit",
      },
    ],
  },
  {
    image: suitJacketUrl,
    title: "Outerwear",
    handle: "outerwear",
    description: "Clothes worn on the upper body in many shapes and forms.",
    panels: [
      {
        group: "suit-jacket",
        image: suitJacketUrl,
        label: "Suit jacket",
      },
      {
        group: "denim-jacket",
        image: denimJacketUrl,
        label: "Denim jacket",
      },
      {
        group: "bomber-jacket",
        image: bomberJacketUrl,
        label: "Bomber jacket",
      },
      {
        group: "leather-jacket",
        image: leatherJacketUrl,
        label: "Leather jacket",
      },
      {
        group: "parka",
        image: parkaUrl,
        label: "Parka",
      },
      {
        group: "puffer-jacket",
        image: pufferJacketUrl,
        label: "Puffer jacket",
      },
      {
        group: "windbreaker",
        image: windbreakerUrl,
        label: "Windbreaker",
      },
      {
        group: "pea-coat",
        image: peaCoatUrl,
        label: "Pea coat",
      },
      {
        group: "trench-coat",
        image: trenchCoatUrl,
        label: "Trench coat",
      },
      {
        group: "cardigan",
        image: cardiganUrl,
        label: "Cardigan",
      },
      {
        group: "coat",
        image: coatUrl,
        label: "Coat",
      },
      {
        group: "jacket",
        image: jacketUrl,
        label: "Jacket",
      },
      {
        group: "ponchos",
        image: ponchosUrl,
        label: "Ponchos",
      },
      {
        group: "shrugs",
        image: shrugsUrl,
        label: "Shrugs",
      },
      {
        group: "vest",
        image: vestUrl,
        label: "Vest",
      },
    ],
  },
  {
    image: cargoPantsUrl,
    title: "Legs clothes",
    handle: "legs-clothes",
    description: "Clothes worn on the lower body in many shapes and forms.",
    panels: [
      {
        group: "cargo-pants",
        image: cargoPantsUrl,
        label: "Cargo pants",
      },
      {
        group: "chinnos",
        image: chinnosUrl,
        label: "Chinnos",
      },
      {
        group: "dress-pants",
        image: dressPantsUrl,
        label: "Dress pants",
      },
      {
        group: "jeans",
        image: jeansUrl,
        label: "Jeans",
      },
      {
        group: "joggers",
        image: joggersUrl,
        label: "Joggers",
      },
      {
        group: "overalls",
        image: overallsUrl,
        label: "Overalls",
      },
      {
        group: "shorts",
        image: shortsUrl,
        label: "Shorts",
      },
      {
        group: "sweat-pants",
        image: sweatPantsUrl,
        label: "Sweat pants",
      },
      {
        group: "culottes",
        image: culottesUrl,
        label: "Culottes",
      },
      {
        group: "formal-shorts",
        image: formalShortsUrl,
        label: "Formal shorts",
      },
      {
        group: "harem-pants",
        image: haremPantsUrl,
        label: "Harem pants",
      },
      {
        group: "jeggings",
        image: jeggingsUrl,
        label: "Jeggings",
      },
      {
        group: "leggings",
        image: leggingsUrl,
        label: "Leggings",
      },
      {
        group: "maxi-skirt",
        image: maxiSkirtUrl,
        label: "Maxi skirt",
      },
      {
        group: "mini-skirt",
        image: miniSkirtUrl,
        label: "Mini skirt",
      },
      {
        group: "palazzo-pants",
        image: palazzoPantsUrl,
        label: "Palazzo pants",
      },
      {
        group: "pencil-skirt",
        image: pencilSkirtUrl,
        label: "Pencil skirt",
      },
      {
        group: "tailored-shorts",
        image: tailoredShortsUrl,
        label: "Tailored shorts",
      },
    ],
  },
  {
    image: sneakersUrl,
    title: "Shoes",
    handle: "shoes",
    description: "Various shoes.",
    panels: [
      {
        group: "sneakers",
        image: sneakersUrl,
        label: "Sneakers",
      },
      {
        group: "sport-shoes",
        image: sportShoesUrl,
        label: "Sport shoes",
      },
      {
        group: "boat-shoes",
        image: boatShoesUrl,
        label: "Boat shoes",
      },
      {
        group: "boots",
        image: bootsUrl,
        label: "Boots",
      },
      {
        group: "chelsea-boots",
        image: chelseaBootsUrl,
        label: "Chelsea boots",
      },
      {
        group: "flip-flops",
        image: flipFlopsUrl,
        label: "Flip flops",
      },
      {
        group: "loafers",
        image: loafersUrl,
        label: "Loafers",
      },
      {
        group: "moccasins",
        image: moccasinsUrl,
        label: "Moccasins",
      },
      {
        group: "oxfords",
        image: oxfordsUrl,
        label: "Oxfords",
      },
      {
        group: "espadrilles",
        image: espadrillesUrl,
        label: "Espadrilles",
      },
      {
        group: "sandals",
        image: sandalsUrl,
        label: "Sandals",
      },
      {
        group: "slippers",
        image: slippersUrl,
        label: "Slippers",
      },
      {
        group: "heels",
        image: heelsUrl,
        label: "Heels",
      },
    ],
  },
  {
    image: beanieUrl,
    title: "Accessories",
    handle: "accessories",
    description: "Various accessories.",
    panels: [
      {
        group: "sunglasses",
        image: sunglassesUrl,
        label: "Sunglasses",
      },
      {
        group: "glasses",
        image: glassesUrl,
        label: "Glasses",
      },
      {
        group: "beanie",
        image: beanieUrl,
        label: "Beanie",
      },
      {
        group: "scarf",
        image: scarfUrl,
        label: "Scarf",
      },
      {
        group: "tie",
        image: tieUrl,
        label: "Tie",
      },
      {
        group: "bow-tie",
        image: bowTieUrl,
        label: "Bow tie",
      },
      {
        group: "gloves",
        image: glovesUrl,
        label: "Gloves",
      },
      {
        group: "baseball-cap",
        image: baseballCapUrl,
        label: "Baseball cap",
      },
      {
        group: "earrings",
        image: earringsUrl,
        label: "Earrings",
      },
      {
        group: "handbag",
        image: handbagUrl,
        label: "Handbag",
      },
      {
        group: "necklace",
        image: necklaceUrl,
        label: "Necklace",
      },
    ],
  },
];

export const getAccessoriesColor = cva([], {
  variants: {
    color: {
      random: "#FFFFFF",
      white: "#FFFFFF",
      black: "#000000",
      light_gray: "#D3D3D3",
      gray: "#808080",
      dark_gray: "#4A4A4A",
      light_blue: "#00C0EF",
      blue: "#007AFF",
      navy_blue: "#0087FF",
      denim: "#0087FF",
      green: "#00A870",
      light_brown: "#C4A484",
      brown: "#6F4E37",
      dark_brown: "#322110",
      yellow: "#FFFF00",
      orange: "#FF8C00",
      pink: "#FF2D55",
      purple: "#800080",
      red: "#FF0000",
      colorful: "#FF00FF",
      blue_red_flannel: "#0087FF",
      flannel: "#FF0000",
      burberry: "#FF8C00",
      hawaiian: "#FFFFFF",
    },
  },
});

export const accessoriesColors = [
  "random",
  "white",
  "black",
  "light_gray",
  "gray",
  "dark_gray",
  "light_blue",
  "blue",
  "navy_blue",
  "denim",
  "green",
  "light_brown",
  "brown",
  "dark_brown",
  "yellow",
  "orange",
  "pink",
  "purple",
  "red",
  "colorful",
  "blue_red_flannel",
  "flannel",
  "burberry",
  "hawaiian",
];

export const loraStatusColorMap = {
  draft: "gray",
  training: "blue",
  published: "green",
  unpublished: "yellow",
  erroneous: "red",
};

export const photoExpressionMap = {
  angry: "Angry",
  confident: "Confident",
  confused: "Confused",
  excited: "Excited",
  happy: "Happy",
  laughing: "Laughing",
  sad: "Sad",
  scared: "Scared",
  serious: "Serious",
  smiling: "Smiling",
};

export const photoBackgroundMap = {
  white: "White",
  lightGray: "Light gray",
  gray: "Gray",
  pink: "Pink",
  purple: "Purple",
  red: "Red",
  blue: "Blue",
  green: "Green",
  brown: "Brown",
  darkGray: "Dark gray",
  black: "Black",
  naturalBg: "Natural",
  colorful: "Colorful",
  city: "City",
  office: "Office",
  library: "Library",
  livingRoom: "Living room",
  forest: "Forest",
  sea: "Sea",
  lake: "Lake",
  river: "River",
};

export const photoAngleMap = {
  front: "Front",
  headshot: "Headshot",
  side: "Side",
  angle: "Angle",
};

export const photoStyleMap = {
  realistic: "Realistic",
  "pixel-art": "Pixel art",
  // "anime-art": "Anime art",
  "oil-painting": "Oil painting",
  "pencil-sketch": "Pencil sketch",
  watercolor: "Watercolor",
  render: "3D Render",
  fantasy: "Fantasy",
  cyberpunk: "Cyberpunk",
  sticker: "Sticker",
};

export const photoFocusMap = {
  "shallow-depth-of-field": "Shallow DoF",
  "deep-focus": "Deep focus",
  "tilt-shift": "Tilt shift",
  bokeh: "Bokeh",
};

export const photoLightingMap = {
  natural: "Natural",
  daylight: "Daylight",
  "golden-hour": "Golden Hour",
  hair: "Hair",
  soft: "Soft",
  hard: "Hard",
  studio: "Studio",
  rim: "Rim",
  neon: "Neon lights",
  broad: "Broad",
  rembrandt: "Rembrandt",
  spotlight: "Spotlight",
};

export const photoMenHairStylesMap = {
  "buzz-cut": "Buzz cut",
  "crew-cut": "Crew cut",
  "curly-cut-with-layers": "Curly cut",
  "long-curly-hair-with-side-part": "Long curly",
  "long-hair": "Long hair",
  "medium-spiked-fade-on-faux-hawk": "Faux hawk",
  ponytail: "Ponytail",
  quiff: "Quiff",
  "short-floppy-with-bangs": "Floppy",
  "side-part": "Side part",
  "textured-floppy-cut": "Floppy cut",
  afro: "Afro",
};

export const photoWomenHairStylesMap = {
  afro: "Afro",
  bangs: "Bangs",
  bun: "Bun",
  "buzz-cut": "Buzz cut",
  chignon: "Chignon",
  "double-bun": "Double bun",
  feathered: "Feathered",
  "fishtail-braid": "Fishtail braid",
  "high-ponytail": "High ponytail",
  "long-bohemian-braids": "Bohemian braids",
  "long-curly": "Long curly",
  "long-gatsby-waves": "Gatsby waves",
  "long-sleek-ponytail": "Sleek ponytail",
  "long-straight": "Long straight",
  "medium-senegalese-twist": "Senegalese twist",
  "medium-two-strand-twists": "Two strand twists",
  ombre: "Ombre",
  short: "Short",
  "short-curly-afro": "Curly afro",
  "short-textured-quiff": "Textured quiff",
  "sleek-bob": "Sleek bob",
  "sleek-straight": "Sleek straight",
  "top-knot": "Top knot",
  "twin-braids": "Twin braids",
};

export const photoMenHairStylesPhotoMap = {
  "buzz-cut": buzzCut,
  "crew-cut": crewCut,
  "curly-cut-with-layers": curlyCutWithLayers,
  "long-curly-hair-with-side-part": longCurlyHairWithSidePart,
  "long-hair": longHair,
  "medium-spiked-fade-on-faux-hawk": mediumSpikedFadeOnFauxHawk,
  ponytail: ponytail,
  quiff: quiff,
  "short-floppy-with-bangs": shortFloppyWithBangs,
  "side-part": sidePart,
  "textured-floppy-cut": texturedFloppyCut,
  afro: afro,
};

export const photoWomenHairStylesPhotoMap = {
  afro: afroW,
  bun: bun,
  bangs: bangs,
  "buzz-cut": buzzCutW,
  chignon: chignon,
  "double-bun": doubleBun,
  feathered: feathered,
  "fishtail-braid": fishtailBraid,
  "high-ponytail": highPonytail,
  "long-bohemian-braids": longBohemianBraids,
  "long-curly": longCurly,
  "long-gatsby-waves": longGatsbyWaves,
  "long-sleek-ponytail": longSleekPonytail,
  "long-straight": longStraight,
  "medium-senegalese-twist": mediumSenegaleseTwist,
  "medium-two-strand-twists": mediumTwoStrandTwists,
  ombre: ombre,
  short: short,
  "short-curly-afro": shortCurlyAfro,
  "short-textured-quiff": shortTexturedQuiff,
  "sleek-bob": sleekBob,
  "sleek-straight": sleekStraight,
  "top-knot": topKnot,
  "twin-braids": twinBraids,
};

export const photoExpressionPhotoMap = {
  angry: angry,
  confident: confident,
  confused: confused,
  excited: excited,
  happy: happy,
  laughing: laughing,
  sad: sad,
  scared: scared,
  serious: serious,
  smiling: smiling,
};

export const photoBackgroundPhotoMap = {
  black: black,
  blue: blue,
  brown: brown,
  city: city,
  colorful: colorful,
  darkGray: darkGray,
  forest: forest,
  gray: gray,
  green: green,
  lake: lake,
  library: library,
  lightGray: lightGray,
  livingRoom: livingRoom,
  naturalBg: naturalBg,
  office: office,
  pink: pink,
  purple: purple,
  red: red,
  river: river,
  sea: sea,
  white: white,
};

export const photoAnglePhotoMap = {
  front: front,
  headshot: headshot,
  side: side,
  angle: angle,
};

export const photoStylePhotoMap = {
  realistic: realistic,
  daylight: daylight,
  "pixel-art": pixelArt,
  // "anime-art": animeArt,
  "oil-painting": oilPainting,
  "pencil-sketch": pencilSketch,
  watercolor: watercolor,
  render: render,
  fantasy: fantasy,
  cyberpunk: cyberpunk,
  sticker: sticker,
};

export const photoFocusPhotoMap = {
  "shallow-depth-of-field": shallowDepthOfField,
  "deep-focus": deepFocus,
  "tilt-shift": tiltShift,
  bokeh: bokeh,
};

export const photoLightingPhotoMap = {
  natural: natural,
  daylight: daylight,
  soft: soft,
  hard: hard,
  studio: studio,
  rim: rim,
  neon: neon,
  broad: broad,
  rembrandt: rembrandt,
  hair: hair,
  spotlight: spotlight,
  "golden-hour": goldenHour,
};

export const photoStyleColorMap = {
  realistic: "indigo",
  "pixel-art": "green",
  // "anime-art": "cyan",
  "oil-painting": "orange",
  "pencil-sketch": "blue",
  watercolor: "pink",
  render: "purple",
  fantasy: "red",
  cyberpunk: "yellow",
  sticker: "teal",
};

export type PhotoExpression =
  | "angry"
  | "confident"
  | "confused"
  | "excited"
  | "happy"
  | "laughing"
  | "sad"
  | "scared"
  | "serious"
  | "smiling";

export type PhotoAngle = "front" | "side" | "angle";

export type PhotoBackground =
  | "black"
  | "blue"
  | "brown"
  | "city"
  | "colorful"
  | "darkGray"
  | "forest"
  | "gray"
  | "green"
  | "lake"
  | "library"
  | "lightGray"
  | "livingRoom"
  | "naturalBg"
  | "office"
  | "pink"
  | "purple"
  | "red"
  | "river"
  | "sea"
  | "white";

export type PhotoLighting =
  | "natural"
  | "daylight"
  | "soft"
  | "hard"
  | "studio"
  | "rim"
  | "neon"
  | "rembrandt"
  | "hair"
  | "spotlight"
  | "golden-hour"
  | "broad";

export type PhotoFocus =
  | "shallow-depth-of-field"
  | "deep-focus"
  | "tilt-shift"
  | "bokeh";

export type PhotoStyle =
  | "realistic"
  | "pixel-art"
  // | "anime-art"
  | "oil-painting"
  | "pencil-sketch"
  | "watercolor"
  | "render"
  | "fantasy"
  | "cyberpunk"
  | "sticker";

export const aspectRatioMap = {
  "1:1": "1:1 Square",
  "16:9": "16:9 Wide",
  "21:9": "16:9 Ultra-wide",
  "3:2": "3:2 Classic",
  "2:3": "2:3 Portrait",
  "4:5": "4:5 Portrait",
  "5:4": "5:4 Square",
  "3:4": "3:4 Classic",
  "4:3": "4:3 Classic",
  "9:16": "9:16 Portrait mobile",
  "9:21": "9:16 Tall",
};

export const aspectRatioSizeMap = {
  "16:9": {
    width: 16,
    height: 9,
  },
  "1:1": {
    width: 16,
    height: 16,
  },
  "21:9": {
    width: 16,
    height: 7,
  },
  "9:21": {
    width: 7,
    height: 16,
  },
  "3:2": {
    width: 16,
    height: 12,
  },
  "2:3": {
    width: 12,
    height: 16,
  },
  "9:16": {
    width: 9,
    height: 16,
  },
  "3:4": {
    width: 12,
    height: 16,
  },
  "4:3": {
    width: 16,
    height: 12,
  },
  "4:5": {
    width: 13,
    height: 16,
  },
  "5:4": {
    width: 16,
    height: 13,
  },
};

export type Outputs = "1" | "2" | "3" | "4";

export type AspectRatio = keyof typeof aspectRatioMap;

export const getPhotoDownloadUrl = (photo: PhotoModel): string => {
  const baseUrl = import.meta.env.VITE_WEB_URL;
  return `${baseUrl}/photos/${photo.name}/download`;
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const upperCaseFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const prettifyString = (string: string): string => {
  if (!string) {
    return "";
  }

  return upperCaseFirstLetter(string).replace(/_/g, " ");
};

export const packNumbers = new Map<string, number>([
  ["headshots", 12],
  ["travel", 12],
  ["time-machine", 8],
]);

export const handleDownload = async (imageUrl: string, fileName: string) => {
  try {
    // Fetch the image as a blob
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // Create a link element
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the image:", error);
  }
};

export const ucFirst = (string: string | null | undefined): string => {
  if (!string) {
    return "";
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getPackOutputs = (pack: string, outputs: number): string => {
  const number = packNumbers.get(pack);

  if (!number) {
    return outputs.toString();
  }

  return Number(outputs * number).toString();
};
